// extracted by mini-css-extract-plugin
export var item = "style-module--item--3rUqs";
export var icon = "style-module--icon--2qJWX";
export var title = "style-module--title--1UDEJ";
export var features = "style-module--features--uvGRK";